import { render, staticRenderFns } from "./CommissionConfigList.vue?vue&type=template&id=4db663a6&"
import script from "./CommissionConfigList.vue?vue&type=script&lang=js&"
export * from "./CommissionConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports